<script lang="ts" setup></script>

<template>
  <BaseLayoutModal :hide-x="true" width="large">
    <template #header> {{ $t("main.modalAuthLoader.title") }} </template>
    <template #content>
      <div class="min-h-[350px] flex items-center justify-center">
        <ModalLoader
          :body-title="$t('main.modalAuthLoader.bodyTitle')"
          :body-subtitle="$t('main.modalAuthLoader.bodySubtitle')" />
      </div>
    </template>
  </BaseLayoutModal>
</template>
